import React from "react";

/**
 * ProductImageFallback - A reusable SVG fallback for missing product images.
 * @param {object} props
 * @param {string} [props.className] - Additional classes for sizing/styling.
 * @param {string} [props['aria-label']] - Optional aria-label for accessibility.
 */
export default function ProductImageFallback({ className = '', ...props }) {
    return (
        <span className={`flex items-center justify-center bg-gray-100 ${className}`.trim()}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full text-gray-300"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-label={props['aria-label'] || 'No product image'}
            >
                <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="1.5" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 15l3-3 2 2 3-3" />
                <circle cx="8.5" cy="8.5" r="1.5" />
            </svg>
            <span className="sr-only">No product image</span>
        </span>
    );
}
